import { createReducer } from 'redux-act';
import { fetchPropertySuccess, setLoading, fetchProperty, clearProperty } from './propertyActions';

const initialState = {
  isLoading: true,
  property: null,
};

export const reducer = createReducer(
  {
    [fetchProperty]: (state) => ({ ...state }),
    [fetchPropertySuccess]: (state, { property }) => ({ ...state, property }),
    [setLoading]: (state, payload) => ({ ...state, isLoading: payload }),
    [clearProperty]: (state) => ({ ...state, property: null }),
  },
  initialState,
);
